import { render, staticRenderFns } from "./LikeList.vue?vue&type=template&id=353273b4"
import script from "./LikeList.vue?vue&type=script&lang=js"
export * from "./LikeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductItem: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/ProductItem.vue').default,SectionContainer: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/SectionContainer.vue').default})
